import React from 'react';
import classNames from 'classnames';
import './index.scss';

interface IMentionDropdownSkeletonProps {
  className?: string;
}

/**
 * Mention 下拉加载骨架（知识库 @ / Skill / 等共用）
 * 第 1 行：icon + 满宽文案条；第 2、3 行左缩进，文案条右缘略短于首行
 */
const MentionDropdownSkeleton: React.FC<IMentionDropdownSkeletonProps> = ({
  className,
}) => (
  <div
    className={classNames('dba-mention-dropdown-skeleton', className)}
    aria-busy="true"
    aria-live="polite"
  >
    <div className="dba-mention-dropdown-skeleton__list">
      <div className="dba-mention-dropdown-skeleton__row">
        <span className="dba-mention-dropdown-skeleton__icon" />
        <span className="dba-mention-dropdown-skeleton__bar" />
      </div>
      {[0, 1].map((key) => (
        <div
          key={key}
          className="dba-mention-dropdown-skeleton__row dba-mention-dropdown-skeleton__row--nested"
        >
          <span className="dba-mention-dropdown-skeleton__icon" />
          <span className="dba-mention-dropdown-skeleton__bar" />
        </div>
      ))}
    </div>
  </div>
);

export default MentionDropdownSkeleton;
